import { Card, Grid, CardContent, Typography } from '@mui/material';
import { purpleText, internalCard, normalText } from '../../styles';

interface Props {
  insured_item:
    | {
        equipment_type: string;
        manufacturer: string;
        year_of_manufacture: number;
        model: string;
        serial_number: string;
        equipment_value: number;
        value_of_accessories: number | null;
        insured_equipament_id: number;
      }[]
    | undefined;
  updateQuoteData: ({
    prods,
    equipament_price,
    value_of_acessories
  }: {
    prods?: number[];
    equipament_price?: number;
    value_of_acessories?: number;
  }) => Promise<void>;
}

export function EquipmentCard({ insured_item: insuredItems }: Props) {
  if (!insuredItems) return null;

  const [insured_item] = insuredItems;

  const currencyFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });

  return (
    <Card
      sx={{
        margin: { xs: '2rem 0.5rem', sm: '2rem 1rem', md: '2rem 2rem' },
        marginTop: 0
      }}
    >
      <CardContent sx={internalCard}>
        <Typography variant="h6" align="left" sx={{ paddingBottom: 1 }}>
          1- Dados do equipamento
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={6} sm={3}>
            <Typography variant="subtitle1" sx={purpleText}>
              Tipo:
            </Typography>
            <Typography variant="subtitle2" sx={normalText}>
              {insured_item.equipment_type}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={2.5}>
            <Typography variant="subtitle1" sx={purpleText}>
              Marca:
            </Typography>
            <Typography variant="subtitle2" sx={normalText}>
              {insured_item.manufacturer}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={2.5}>
            <Typography variant="subtitle1" sx={purpleText}>
              Modelo:
            </Typography>
            <Typography variant="subtitle2" sx={normalText}>
              {insured_item.model}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={4}>
            <Typography variant="subtitle1" sx={purpleText}>
              Ano de fabricação:
            </Typography>
            <Typography variant="subtitle2" sx={normalText}>
              {insured_item.year_of_manufacture}
            </Typography>
          </Grid>
        </Grid>
        <Grid container sx={{ paddingTop: 2 }} rowSpacing={2} columnSpacing={8}>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" sx={purpleText}>
              Valor do equipamento
            </Typography>
            <Typography variant="subtitle2" sx={normalText}>
              {currencyFormatter.format(insured_item.equipment_value)}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle2" sx={purpleText}>
              Valor dos acessórios
            </Typography>
            <Typography variant="subtitle2" sx={normalText}>
              {currencyFormatter.format(insured_item.value_of_accessories || 0)}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
